import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const forgeProjectServicedeskRoute: InvariantJiraRoute = {
	name: 'forge-spa-project-servicedesk',
	path: '/jira/:projectType(servicedesk)/projects/:projectKey/apps/:appId/:envId/:route?',
};
